<template>
    <div>
        <div class="card">
            <div class="card-header">
                项目基本信息
            </div>
            <table class="table table-bordered mb-0" v-if="projectInfo && projectImplementationInfo">
                <tbody>
                <tr>
                    <th class="text-center align-middle" style="width: 10%">项目类型</th>
                    <td class="text-left align-middle" colspan="3">{{projectInfo.categoryName}}</td>
                    <th class="text-center align-middle" style="width: 10%">项目批次</th>
                    <td class="text-left align-middle" colspan="3">{{projectInfo.batchName}}</td>
                </tr>
                <tr>
                    <th class="text-center align-middle" style="width: 10%">开始日期</th>
                    <td class="text-left align-middle" style="width: 15%">{{projectImplementationInfo.startDateString}}</td>
                    <th class="text-center align-middle" style="width: 10%">结束日期</th>
                    <td class="text-left align-middle" style="width: 15%">{{projectImplementationInfo.endDateString}}</td>
                    <th class="text-center align-middle" style="width: 10%">计划人数</th>
                    <td class="text-left align-middle" style="width: 15%">{{projectInfo.studentCount}}</td>
                    <th class="text-center align-middle" style="width: 10%">联系人</th>
                    <td class="text-left align-middle" style="width: 15%">{{projectImplementationInfo.personName}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import projectApi from "@/utils/api/project";
export default {
    name: "ProjectInfoView",
    props: {
        projectId: {type: String, required: true},
    },
    data: function () {
        return {
            projectInfo: {},
            projectImplementationInfo: {},
        };
    },
    mounted() {
        this.getProjectInfo();
        this.getProjectImplementationInfo();
    },
    methods: {
        getProjectInfo() {
            projectApi.project.getProjectInfo(this.projectId).then(res => {
                this.projectInfo = res.data;
            });
        },
        getProjectImplementationInfo() {
            projectApi.project.implementation.getProjectImplementationInfo(this.projectId).then(res => {
                this.projectImplementationInfo = res.data;
            });
        },
    }
}
</script>

<style scoped>

</style>